import { qzTrayPublicCertificateApi } from "../../api";

/**
 * 🔓 QzTrayPublicCertificateService
 *
 * Gestiona la obtención del certificado público (cert.pem) utilizado
 * para inicializar una conexión segura con QZ Tray.
 *
 * ✅ Funcionalidad principal:
 * - Obtener el contenido del certificado activo.
 */
const QzTrayPublicCertificateService = {

  /**
   * 📜 Obtener certificado público activo (cert.pem)
   * GET /api/qztray/certificates/public
   */
  getPublicCertificate: async () => {
    const response = await qzTrayPublicCertificateApi.fetchCustom(``);
    return response.data; // <- Esto es el PEM en texto
  },
};

export default QzTrayPublicCertificateService;
